<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        v-if="!editable && editMode"
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Experiences') }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">
      <form v-on:submit.prevent="save(candidateEdit)" class="list-group">
        
        <div 
          v-for="(experience, index) in candidateEdit.experiences"
          :key="index"
          class="list-group-item p-4">
          
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('Company') }} *</label>
            <div class="col-sm-9">
              <input v-autofocus class="form-control" type="text" v-model="experience.company">
              <ValidateMessage :error="validateErrors['experiences.' + index + '.company']" />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('Position') }} *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" v-model="experience.position">
              <ValidateMessage :error="validateErrors['experiences.' + index + '.position']" />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('Period') }}</label>
            <div class="col-sm-9">
              <div class="d-flex">
                <div class="mr-3">
                  <input-month
                    v-model="experience.start_date"
                    :placeholder="$t('Start date')"
                    width="110"
                    initialSelect="year">
                    </input-month>
                  <ValidateMessage :error="validateErrors['experiences.' + index + '.start_date']" />
                </div>
                <div class="mr-3 pt-1 pb-1" v-if="!experience.current_job">
                  até
                </div>
                <div class="mr-3" v-if="!experience.current_job">
                  <input-month
                    v-model="experience.end_date"
                    :placeholder="$t('End date')"
                    width="110"
                    initialSelect="year">
                    </input-month>
                  <ValidateMessage :error="validateErrors['experiences.' + index + '.end_date']" />
                </div>
                <div class="form-control-plaintext">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" v-model="experience.current_job">
                      Atual
                    </label>
                  </div>
                  <ValidateMessage :error="validateErrors['experiences.' + index + '.current_job']" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('Attributions') }}</label>
            <div class="col-sm-9">
              <textarea-autosize
                v-model="experience.attributes"
                :min-height="60"
                class="form-control">
                </textarea-autosize>
              <ValidateMessage :error="validateErrors['experiences.' + index + '.attributes']" />
            </div>
          </div>

          <a href="javascript:void(0)" @click="candidateEdit.experiences.splice(index, 1);">{{ $t('Remove') }}</a>
        </div>

        <div class="mt-3 mb-3">
          <a href="javascript:void(0)" @click="candidateEdit.experiences.push({})">{{ $t('Add company') }}</a>
        </div>

        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>

      </form>
    </div>
    <div class="card-body" v-if="!editable && filled">
      <ul class="experience-list">
        <li 
          v-for="(experience, index) in candidate.experiences"
          :key="index"
          class="row">
          <div class="col-sm-3"><span class="date">{{ getFullDate(experience) }}</span></div>
          <div class="col-sm-9">
            <div>{{ experience.company }}</div>
            <div><strong>{{ experience.position }}</strong></div>
            <div class="attributes">{{ experience.attributes }}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import InputMonth from '@/components/Fields/InputMonth'
import moment from 'moment'

export default {
  name: 'CandidateProfileExperience',
  components: {
    InputMonth
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    filled () {
      return this.candidate.experiences && this.candidate.experiences.length
    }
  },
  methods: {
    /*
    editSection
    */
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = {
        _id: this.candidate._id,
        experiences: Array.isArray(this.candidate.experiences) ? this.candidate.experiences : []
      }
    },
    /*
    save
    */
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    getFullDate
    */
    getFullDate (experience) {
      const startDate = experience.start_date ? moment.utc(experience.start_date).format('MM/YYYY') : null
      const endDate = experience.end_date ? moment.utc(experience.end_date).format('MM/YYYY') : null
      const currentJob = experience.current_job ? 'Atual' : null

      return [startDate, (currentJob || endDate)].filter(v => v).join(' - ')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .experience-list{
    list-style: none;
    padding: 0;
    margin: 0; 
  }
    .experience-list > li{
      margin-bottom: 1.3em;
    }
    .experience-list .date{
      font-size: 0.9em;
      opacity: 0.75; 
    }
    .experience-list .attributes{
      margin: 0.5em 0 0 0;
      white-space: pre-wrap;
    }
</style>


// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileExperience.vue